import React, { useCallback } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import {
  saveSelectedAddPetModal,
  setPowerUpErrors,
} from '../../../actions';
import { useTranslations } from '../../../hooks';
import { validatePowerupsSelected } from '../../../util';
import ill10 from '../../../assets/ills/ill-10.svg';

import plusIcon from '../../../assets/plus-circle-icon.svg';

import './MyPetsContainer.css';
import { QUOTE_MAX_SIZE } from '../../../constants';

const ADD_PET_ID = 'btn-add-anohter-pet';

const MyPetsContainer = () => {
  const { t } = useTranslations('quoting', 'myPets');
  const dispatch = useDispatch();
  const buttonRef = React.useRef(null);
  const {
    data,
    petQuoteSelected,
  } = useSelector(({ quoting }) => quoting, shallowEqual);

  const handleAddPetClick = useCallback(() => {
    if (!data) {
      return;
    }
    buttonRef.current?.blur();

    const petQuoteRateItem = data.ebPetQuoteResponseList
      .find((pqRateItem) => pqRateItem.petQuoteId === petQuoteSelected);
    const powerUpValidation = validatePowerupsSelected(petQuoteRateItem);
    if (!powerUpValidation.isValid) {
      dispatch(setPowerUpErrors(powerUpValidation.modifierIdNotSelectedList));
      return;
    }

    dispatch(saveSelectedAddPetModal(true));
  }, [data, dispatch, petQuoteSelected]);

  function renderTitle() {
    return (
      <>
        <button
          ref={buttonRef}
          aria-controls="addAnotherPetModalmodalContainer"
          aria-label={t('addAnotherPet')}
          className="My-pets-add-pet-button-enrollment"
          id={ADD_PET_ID}
          onClick={handleAddPetClick}
          onKeyPress={handleAddPetClick}
          type="button"
        >
          <img
            alt=""
            className="My-pets-add-icon"
            src={plusIcon}
          />

          <span className="My-pets-add-pet-button-text">
            {t('addAnotherPet')}
          </span>
        </button>

        <section aria-label={t('addPetDiscountDetails')}>
          <span className="My-pets-discount">
            {t('discount')}
          </span>
        </section>
      </>
    );
  }

  return (
    <div className="My-pets-container">
      <div className="My-pets-title-container">
        {data?.ebPetQuoteResponseList?.length < QUOTE_MAX_SIZE
          ? renderTitle()
          : null}
      </div>

      <img
        alt=""
        aria-hidden
        className="Quote-content-image-10 No-mobile No-tablet"
        src={ill10}
      />
    </div>
  );
};

export { MyPetsContainer };
